import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/_layout/real-time-alerts")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/dashboard/_layout/real-time-alerts"!</div>;
}
